import React from 'react';
import styled from 'styled-components';
import { MenuItem } from './MenuItem';
import { theme } from '../styles/theme';

const CategorySection = styled.section`
  margin-bottom: ${theme.spacing['2xl']};
  
  @media (max-width: ${theme.breakpoints.sm}) {
    margin-bottom: ${theme.spacing.xl};
  }
`;

const CategoryHeader = styled.div`
  margin-bottom: ${theme.spacing.lg};
  padding: ${theme.spacing.lg} 0 ${theme.spacing.sm} 0;
  
  @media (max-width: ${theme.breakpoints.sm}) {
    margin-bottom: ${theme.spacing.md};
    padding: ${theme.spacing.md} 0 ${theme.spacing.xs} 0;
  }
`;

const CategoryTitle = styled.h2`
  font-size: ${theme.fontSizes['2xl']};
  color: ${theme.colors.text.primary};
  margin-bottom: ${theme.spacing.sm};
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);
  
  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: ${theme.fontSizes.xl};
    gap: ${theme.spacing.sm};
  }
`;

const CategoryIcon = styled.span`
  font-size: ${theme.fontSizes['2xl']};
`;



const ItemsGrid = styled.div`
  display: grid;
  gap: ${theme.spacing.md};
  grid-template-columns: 1fr;
  
  @media (min-width: ${theme.breakpoints.sm}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: ${theme.breakpoints.md}) {
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  }
  
  @media (min-width: ${theme.breakpoints.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const SubcategoryTitle = styled.h3`
  font-size: ${theme.fontSizes.xl};
  color: ${theme.colors.text.primary};
  margin: ${theme.spacing.xl} 0 ${theme.spacing.lg} 0;
  padding-bottom: ${theme.spacing.sm};
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1.5px;
  position: relative;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  
  @media (max-width: ${theme.breakpoints.sm}) {
    font-size: ${theme.fontSizes.lg};
    margin: ${theme.spacing.lg} 0 ${theme.spacing.md} 0;
    letter-spacing: 1px;
  }
  
  /* 🎨 SOFISTIKE ALT ÇİZGİ */
  &::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 60px;
    height: 3px;
    background: ${theme.colors.gradient.accent};
    border-radius: 2px;
    box-shadow: 
      0 2px 10px rgba(245, 158, 11, 0.4),
      0 0 20px rgba(99, 102, 241, 0.2);
    animation: elegantUnderline 6s ease-in-out infinite;
  }
  
  @keyframes elegantUnderline {
    0%, 100% { 
      box-shadow: 
        0 2px 10px rgba(245, 158, 11, 0.4),
        0 0 20px rgba(99, 102, 241, 0.2);
      width: 60px;
    }
    50% { 
      box-shadow: 
        0 3px 15px rgba(245, 158, 11, 0.5),
        0 0 30px rgba(99, 102, 241, 0.3);
      width: 70px;
    }
  }
`;

const SubcategorySection = styled.div`
  margin-bottom: ${theme.spacing.xl};
  
  @media (max-width: ${theme.breakpoints.sm}) {
    margin-bottom: ${theme.spacing.lg};
  }
`;

export const MenuCategory = ({ category }) => {
  // Alt kategorilere göre ürünleri grupla (sadece fırın ürünleri için)
  const groupItemsBySubcategory = (items) => {
    if (category.id !== 'pides') {
      return { all: items };
    }
    
    const grouped = {
      lahmacun: [],
      cantik: [],
      pide: []
    };
    
    items.forEach(item => {
      if (item.category) {
        grouped[item.category].push(item);
      } else {
        // Kategori belirtilmemişse pide olarak kabul et
        grouped.pide.push(item);
      }
    });
    
    return grouped;
  };

  const groupedItems = groupItemsBySubcategory(category.items);

  return (
    <CategorySection id={category.id}>
      <CategoryHeader>
        <CategoryTitle>
          {category.icon && <CategoryIcon>{category.icon}</CategoryIcon>}
          {category.name}
        </CategoryTitle>
      </CategoryHeader>
      
      {category.id === 'pides' ? (
        // Fırın ürünleri için alt kategorilerle göster
        <>
          {/* Lahmacun */}
          {groupedItems.lahmacun.length > 0 && (
            <SubcategorySection>
              <ItemsGrid>
                {groupedItems.lahmacun.map((item) => (
                  <MenuItem key={item.id} item={item} categoryId={category.id} />
                ))}
              </ItemsGrid>
            </SubcategorySection>
          )}
          
          {/* Cantıklar */}
          {groupedItems.cantik.length > 0 && (
            <SubcategorySection>
              <SubcategoryTitle>Cantıklar</SubcategoryTitle>
              <ItemsGrid>
                {groupedItems.cantik.map((item) => (
                  <MenuItem key={item.id} item={item} categoryId={category.id} />
                ))}
              </ItemsGrid>
            </SubcategorySection>
          )}
          
          {/* Pideler */}
          {groupedItems.pide.length > 0 && (
            <SubcategorySection>
              <SubcategoryTitle>Pideler</SubcategoryTitle>
              <ItemsGrid>
                {groupedItems.pide.map((item) => (
                  <MenuItem key={item.id} item={item} categoryId={category.id} />
                ))}
              </ItemsGrid>
            </SubcategorySection>
          )}
        </>
      ) : (
        // Diğer kategoriler için normal gösterim
        <ItemsGrid>
          {category.items.map((item) => (
            <MenuItem key={item.id} item={item} categoryId={category.id} />
          ))}
        </ItemsGrid>
      )}
    </CategorySection>
  );
};
